module.exports = __webpack_public_path__ + "img/cutaway_parked.9e4abf31.svg";